import { createFileRoute } from '@tanstack/react-router';
import { LazyPage } from './-route-layouts';
import { WorkspaceCustomSmsSendersPage } from './-route-pages';

function WorkspaceCustomSmsSendersRoute() {
  return (
    <LazyPage>
      <WorkspaceCustomSmsSendersPage />
    </LazyPage>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/settings/actions/sms-providers/senders')({
  component: WorkspaceCustomSmsSendersRoute,
});
